import { getAccountActionTypes, updateSelectedAccountActionTypes } from './actions';

const initialState = {
  account: null,
  company: null,
  customer: null,
  loading: false,
  error: null,
};

const handleGetAccountRequest = (state) => ({
  ...state,
  loading: true,
});

const normalizeAccounts = (accounts) => {
  const normalizesAccounts = [];
  accounts.forEach((account) => {
    normalizesAccounts[account.id] = account;
  });
  return normalizesAccounts;
};

const handleGetAccountSuccess = (state, { data }) => ({
  ...state,
  customer: {
    magnetaAlias: data.magneta_alias,
  },
  accounts: data.accounts,
  account: data.accounts[0],
  normalizedAccounts: normalizeAccounts(data.accounts),
  company: data.company,
  loading: false,
});

const handleGetAccountError = (state, action) => ({
  ...state,
  loading: false,
  error: action.error,
});

const updateSelectedAccount = (state, { account }) => ({
  ...state,
  account,
});

export default (state = initialState, action) => {
  const handlers = {
    [updateSelectedAccountActionTypes.success]: updateSelectedAccount,
    [getAccountActionTypes.request]: handleGetAccountRequest,
    [getAccountActionTypes.success]: handleGetAccountSuccess,
    [getAccountActionTypes.error]: handleGetAccountError,
  };
  return handlers[action.type] ? handlers[action.type](state, action) : state;
};
